// extracted by mini-css-extract-plugin
module.exports = {"tabs":"tabs___3CkSU","tab":"tab___1J-3I","active":"active___8ltJb"};